import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-new-report',
  templateUrl: './help-new-report.component.html',
  styleUrls: ['./help-new-report.component.scss']
})
export class HelpNewReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
